import { TiktokIcon } from '@nimbus-ds/icons';
import { MenuButton } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useHandleMenuClick } from 'App/hooks';
import { menuPrimaryTikTokClick } from './tracking';

const PATH = '/apps/social-tiktok/';

function TikTokMenu() {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();
  const { handleClickItem } = useHandleMenuClick();

  return (
    <MenuButton
      as={Link}
      to={PATH}
      startIcon={TiktokIcon}
      onClick={() => {
        menuPrimaryTikTokClick();
        handleClickItem();
      }}
      active={pathname === PATH}
      label={`${t('menu.salesChannels.more.tiktok')}`}
    />
  );
}

export default TikTokMenu;
